module.exports = __webpack_public_path__ + "media/images/partners/5-a1e736d08282cabc70cba354eec426d8.png";